<template>
    <div style="width: 100%;">
        <v-row justify="center">
            <v-col cols="12" lg="3" md="5" sm="7">
                <v-card shaped raised v-if="!success">
                    <v-card-title>
                        Passwort vergessen
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" lazy-validation v-model="valid">
                            <v-text-field label="E-Mail-Adresse" :rules="emailRules" v-model="email" prepend-inner-icon="mdi-at" clearable></v-text-field>
                            <v-btn class="mt-3" color="secondary" block :disabled="!valid" @click="postData">E-Mail senden</v-btn>
                            <v-btn class="mt-3" color="secondary" block text :to="{ name: 'AuthLogin'}">Login</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
                <v-card shaped raised v-if="success">
                    <v-card-title>
                        Erfolgreich versendet!
                    </v-card-title>
                    <v-card-text>
                        <v-alert type="success">
                            Die E-Mail wurde erfolgreich versendet! Bitte überprüfen Sie ihr Postfach und ggf. auch Ihren Spam-Ordner.
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "auth-forgot-password-content",
        data: () => ({
            success: false,
            valid: true,
            email: '',
            emailRules: [
                v => !!v || 'E-Mail-Adresse wird benötigt.',
                v => /.+@.+\..+/.test(v) || 'E-Mail-Adresse ist ungültig.',
            ],
        }),
        created() {
            var paramEmail = new URLSearchParams(window.location.search).get('email');
            if (paramEmail){
                this.email = paramEmail;
            }
        },
        methods: {
            ...mapActions({
               forgotPassword: 'user/forgotPassword'
            }),
            postData() {
                if (this.$refs.form.validate()){
                    this.forgotPassword({'email': this.email}).then((response) => {
                        console.log(response.data);
                        this.success = true;
                    }).catch( (error) => {
                        console.log(error);
                        this.$toast.error('Die E-Mail konnte nicht versendet werden.', {
                            timeout: 5000,
                        });
                    });
                }
            }
        },
    }
</script>

<style scoped>

</style>